/** Props for `Icon`. */
export interface IconProps {
  /** A Font Awesome icon name without its `fa-` prefix, e.g. `arrow-left`. */
  name: string;
  /** Brand icons (e.g. `google`) live in Font Awesome's brands style. */
  brand?: boolean;
}

/**
 * A decorative Font Awesome icon (QZ-D47). Every control that shows one keeps its own text
 * or `aria-label`, so the icon is hidden from assistive technology and nothing depends on the
 * kit having loaded.
 *
 * Font Awesome's kit replaces the `<i>` with an `<svg>` behind React's back. The wrapping
 * `<span>`, keyed by the icon, is what React owns: a different icon remounts the span rather
 * than updating an `<i>` that is no longer in the document.
 */
export const Icon = ({ name, brand }: IconProps) => (
  <span key={name} className="qz-icon" aria-hidden="true">
    <i className={`${brand ? 'fa-brands' : 'fa-solid'} fa-${name}`} />
  </span>
);

export default Icon;
